export const GRAPH_COLORS = [
    "#79cbf2",
    "#eef279",
    "#d379f2",
    "#79f2b0",
    "#7989f2",
    "#acf279",
    "#f279d0",
    "#79f2f1",
    "#f2ce79",
    "#ab79f2",
    "#79f287",
    "#f2798e",
    "#79b1f2",
    "#d5f279",
    "#ec79f2",
    "#79f2c9",
    "#f2a679",
    "#8279f2",
    "#93f279",
    "#f279b7",
    "#79daf2",
    "#f2e779",
    "#c479f2",
    "#79f2a0",
    "#f27d79",
    "#7998f2",
    "#bcf279",
    "#f279df",
    "#79f2e2",
    "#f2bf79",
    "#9b79f2",
    "#7af279",
    "#f2799e",
    "#79c1f2",
    "#e4f279",
    "#dd79f2",
    "#79f2ba",
    "#f29679",
    "#797ff2",
    "#a3f279",
    "#f279c6",
    "#79e9f2",
    "#f2d879",
    "#b479f2",
    "#79f291",
    "#f27985",
    "#79a8f2",
    "#cbf279",
    "#f279ef",
    "#79f2d3",
    "#f2af79",
    "#8c79f2",
    "#8af279",
    "#f279ad",
    "#79d0f2",
    "#f2f179",
    "#cd79f2",
    "#79f2aa",
    "#f28779",
    "#798ff2",
    "#b2f279",
    "#f279d6",
    "#79f2ec",
    "#f2c879",
    "#a579f2",
    "#79f282",
    "#f27994",
    "#79b7f2",
    "#dbf279",
    "#e679f2",
    "#79f2c3",
    "#f2a079",
    "#7c79f2",
    "#99f279",
    "#f279bd",
    "#79e0f2",
    "#f2e179",
    "#be79f2",
    "#79f29b",
    "#f2797b",
    "#799ef2",
    "#c2f279",
    "#f279e5",
    "#79f2dc",
    "#f2b979",
    "#9579f2",
    "#80f279",
    "#f279a4",
    "#79c7f2",
    "#eaf279",
    "#d779f2",
    "#79f2b4",
    "#f29079",
    "#7985f2",
    "#a9f279",
    "#f279cc",
    "#79eff2",
    "#f2d279",
    "#ae79f2",
    "#79f28b",
    "#f2798a",
    "#79aef2",
    "#d1f279",
    "#f079f2",
    "#79f2cd",
    "#f2a979",
    "#8679f2",
    "#90f279",
    "#f279b3",
    "#79d6f2",
    "#f2eb79",
    "#c779f2",
    "#79f2a4",
    "#f28179",
    "#7995f2",
    "#b8f279",
    "#f279db",
    "#79f2e6",
    "#f2c279",
    "#9f79f2",
    "#79f27c",
    "#f2799a",
    "#79bdf2",
    "#e1f279",
    "#e179f2",
    "#79f2bd",
    "#f29a79",
    "#797cf2",
    "#9ff279",
    "#f279c2",
    "#79e6f2",
    "#f2db79",
    "#b879f2",
    "#79f295",
    "#f27981",
    "#79a4f2",
    "#c8f279",
    "#f279eb",
    "#79f2d6",
    "#f2b379",
    "#9079f2",
    "#86f279",
    "#f279a9",
    "#79cdf2",
    "#f0f279",
    "#d179f2",
    "#79f2ae",
    "#f28a79",
    "#798bf2",
    "#aff279",
    "#f279d2",
    "#79f2ef",
    "#f2cc79",
    "#a979f2",
    "#79f285",
    "#f27990",
    "#79b4f2",
    "#d7f279",
    "#ea79f2",
    "#79f2c7",
    "#f2a379",
    "#8079f2",
    "#96f279",
    "#f279b9",
    "#79dcf2",
    "#f2e579",
    "#c279f2",
    "#79f29e",
    "#f27b79",
    "#799bf2",
    "#bef279",
    "#f279e1",
    "#79f2e0",
    "#f2bc79",
    "#9979f2",
    "#7df279",
    "#f279a0",
    "#79c3f2",
    "#e7f279",
    "#db79f2",
    "#79f2b7",
    "#f29479",
    "#7982f2",
    "#a5f279",
    "#f279c8",
    "#79ecf2",
    "#f2d579",
    "#b279f2",
    "#79f28f",
    "#f27987",
    "#79aaf2",
    "#cef279",
    "#f279f1",
    "#79f2d0",
    "#f2ad79",
    "#8a79f2",
    "#8cf279",
    "#f279af",
    "#79d3f2",
    "#f2ee79",
    "#cb79f2",
    "#79f2a8",
    "#f28479",
    "#7991f2",
    "#b4f279",
    "#f279d8",
    "#79f2e9",
    "#f2c679",
    "#a379f2",
    "#79f27f",
    "#f27996",
    "#79baf2",
    "#ddf279",
    "#e479f2",
    "#79f2c1",
    "#f29d79",
    "#7a79f2",
    "#9bf279",
    "#f279bf",
    "#79e2f2",
    "#f2df79",
    "#bc79f2",
    "#79f298",
    "#f2797d",
    "#79a1f2",
    "#c4f279",
    "#f279e7",
    "#79f2da",
    "#f2b779",
    "#9379f2",
    "#82f279",
    "#f279a6",
    "#79c9f2",
    "#ecf279",
    "#d579f2",
    "#79f2b1",
    "#f28e79",
    "#7988f2",
    "#abf279",
    "#f279ce",
    "#79f2f2",
    "#f2d079",
    "#ac79f2",
    "#79f289",
    "#f2798d",
    "#79b0f2",
    "#d3f279",
    "#ee79f2",
    "#79f2ca",
    "#f2a779",
    "#8479f2",
    "#92f279",
    "#f279b5",
    "#79d9f2",
    "#f2e979",
    "#c579f2",
    "#79f2a2",
    "#f27f79",
    "#7997f2",
    "#baf279",
    "#f279de",
    "#79f2e3",
    "#f2c079",
    "#9d79f2",
    "#79f279",
    "#f2799c",
    "#79c0f2",
    "#e3f279",
    "#de79f2",
    "#79f2bb",
    "#f29879",
    "#797ef2",
    "#a1f279",
    "#f279c5",
    "#79e8f2",
    "#f2d979",
    "#b679f2",
    "#79f292",
    "#f27983",
    "#79a7f2",
    "#caf279",
    "#f279ed",
    "#79f2d4",
    "#f2b179",
    "#8d79f2",
    "#88f279",
    "#f279ac",
    "#79cff2",
    "#f2f279",
    "#cf79f2",
    "#79f2ab",
    "#f28879",
    "#798df2",
    "#b1f279",
    "#f279d4",
    "#79f2ed",
    "#f2ca79",
    "#a679f2",
    "#79f283",
    "#f27993",
    "#79b6f2",
    "#d9f279",
    "#e879f2",
    "#79f2c4",
    "#f2a179",
    "#7e79f2",
    "#98f279",
    "#f279bb",
    "#79def2",
    "#f2e379",
    "#bf79f2",
    "#79f29c",
    "#f2797a",
    "#799df2",
    "#c0f279",
    "#f279e4",
    "#79f2de",
    "#f2ba79",
    "#9779f2",
    "#7ff279",
    "#f279a2",
    "#79c5f2",
    "#e9f279",
    "#d879f2",
    "#79f2b5",
    "#f29279",
    "#7984f2",
    "#a7f279",
    "#f279cb",
    "#79eef2",
    "#f2d379",
    "#b079f2",
    "#79f28d",
    "#f27989",
    "#79acf2",
    "#d0f279",
    "#f179f2",
    "#79f2ce",
    "#f2ab79",
    "#8779f2",
    "#8ef279",
    "#f279b2",
    "#79d5f2",
    "#f2ec79",
    "#c979f2",
    "#79f2a6",
    "#f28279",
    "#7993f2",
    "#b7f279",
    "#f279da",
    "#79f2e7",
    "#f2c479",
    "#a079f2",
    "#79f27d",
    "#f27999",
    "#79bcf2",
    "#dff279",
    "#e279f2",
    "#79f2bf",
    "#f29b79",
    "#797af2",
    "#9ef279",
    "#f279c1",
    "#79e4f2",
    "#f2dd79",
    "#b979f2",
    "#79f296",
    "#f27980",
    "#79a3f2",
    "#c6f279",
    "#f279ea",
    "#79f2d8",
    "#f2b479",
    "#9179f2",
    "#85f279",
    "#f279a8",
    "#79cbf2",
    "#eff279",
    "#d279f2",
    "#79f2af",
    "#f28c79",
    "#798af2",
    "#adf279",
    "#f279d1",
    "#79f2f1",
    "#f2cd79",
    "#aa79f2",
    "#79f287",
    "#f2798f",
    "#79b2f2",
    "#d6f279",
    "#eb79f2",
    "#79f2c8",
    "#f2a579",
    "#8179f2",
    "#94f279",
    "#f279b7",
    "#79dbf2",
    "#f2e679",
    "#c379f2",
    "#79f2a0",
    "#f27c79",
    "#7999f2",
    "#bdf279",
    "#f279e0",
    "#79f2e1",
    "#f2be79",
    "#9a79f2",
    "#7bf279",
    "#f2799e",
    "#79c2f2",
    "#e5f279",
    "#dc79f2",
    "#79f2b9",
    "#f29579",
    "#7980f2",
    "#a4f279",
    "#f279c7",
    "#79eaf2",
    "#f2d779",
    "#b479f2",
    "#79f290",
    "#f27985",
    "#79a9f2",
    "#ccf279",
    "#f279ef",
    "#79f2d2",
    "#f2ae79",
    "#8b79f2",
    "#8bf279",
    "#f279ae",
    "#79d1f2",
    "#f2f079",
    "#cd79f2",
    "#79f2a9",
    "#f28679",
    "#7990f2",
    "#b3f279",
    "#f279d6",
    "#79f2eb",
    "#f2c779",
    "#a479f2",
    "#79f281",
    "#f27995",
    "#79b8f2",
    "#dcf279",
    "#e679f2",
    "#79f2c2",
    "#f29f79",
    "#7c79f2",
    "#9af279",
    "#f279bd",
    "#79e1f2",
    "#f2e079",
    "#bd79f2",
    "#79f29a",
    "#f2797c",
    "#799ff2",
    "#c3f279",
    "#f279e6",
    "#79f2db",
    "#f2b879",
    "#9579f2",
    "#81f279",
    "#f279a4",
    "#79c8f2",
    "#ebf279",
    "#d679f2",
    "#79f2b3",
    "#f28f79",
    "#7986f2",
    "#aaf279",
    "#f279cd",
    "#79f0f2",
    "#f2d179",
    "#ae79f2",
    "#79f28a",
    "#f2798b",
    "#79aff2",
    "#d2f279",
    "#ef79f2",
    "#79f2cc",
    "#f2a879",
    "#8579f2",
    "#90f279",
    "#f279b4",
    "#79d7f2",
    "#f2ea79",
    "#c779f2",
    "#79f2a3",
    "#f28079",
    "#7996f2",
    "#b9f279",
    "#f279dc",
    "#79f2e5",
    "#f2c179",
    "#9e79f2",
    "#79f27b",
    "#f2799b"
]